<template>
  <div name="max" class="">
    <div class="w-95p mx-auto pb-10 grid md:grid-cols-2 grid-cols-1 space-x-6">
      <div class="w-11/12 mx-auto">
        <h2 class="text-base font-bold mb-4">Documents</h2>

        <ResourceList
          :hasAccess="!shouldShowUpgrade"
          :type="typeSelected"
        ></ResourceList>
      </div>

      <div class="w-11/12 mx-auto">
        <h2 class="text-base font-bold mb-4">Videos</h2>
        <div class="table-wrapper">
          <div v-if="errored" class="empty">
            <p>
              We are not able to retrieve this information at the moment, please
              try back later
            </p>
          </div>

          <div id="content-area" v-else>
            <div
              style="width: 100%; text-align: center"
              class="spin-holder mt-4"
              v-if="loading"
            >
              <i class="spinner fa fa-spinner fa-spin"></i>
              <p>Loading Videos</p>
            </div>

            <div class="mb-10 pb-20" v-else>

              <div v-for="section in sectionList" :key="section.value">
              <table
                class="w-full mx-auto mb-2 h-10 pt-2 align-text-bottom bg-white rounded text-left text-gray-600"
              >
                <thead class="bg-gray-200 w-full">
                  <tr>
                    <th class="font-bold pl-4">{{ section.title }}</th>
                   
                  </tr>
                </thead>
              </table>

              <table
                class="table-wrapper w-full bg-white mx-auto rounded shadow-sm mb-6"
              >
                <tbody>
                  <tr v-for="(video, index) in filteredList(section)" :key="video.id">
                    <td class="w-1 px-4 text-left">
                      <i class="fas fa-video opacity-75"></i>
                    </td>
                    <td class="w-10/12 font-semibold">{{ video.title }}</td>
                    <td class="2u text-left">
                      <a
                        @click="display(video)"
                        class="text-xs cursor-pointer pr-4 text-blue-400"
                        v-if="shouldDisplay(index)"
                        >View</a
                      >
                      <i v-else class="fas fa-lock text-yellow-500 text-lg"></i>
                    </td>
                  </tr>
                </tbody>
              </table>

 </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <modalvideo
      :url="loadVideoPath()"
      @close="showModalVideo = false"
      v-if="selectedVideo != undefined && showModalVideo"
      v-show="showModalVideo"
    ></modalvideo>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { BaseService } from "@/services/school.service";
import { upgradeMixin } from "@/mixins/upgradeMixin.js";

const ResourceList = () => import("@/components/library/TheResourceList.vue");
const modalvideo = () => import("@/components/ModalVideo.vue");


export default {
  name: "max",
  props: [],
  mixins: [upgradeMixin],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    componentLoaded() {
      return this.videos.length > 0;
    },
    orderedVideos() {
      return _.orderBy(this.videos, ["display_order", "title"]);
    },
  },
  data() {
    return {
      loading: true,
      errored: false,
      typeSelected: null,
      selectedVideo: {},
      showModalVideo: false,
      videos: [],
      sectionList: [
        { key: "what_is_dance", title: "What is Dance : Core CPD Programme" },
        { key: "how_to_structure", title: "How to Structure a Dance Lesson" },
        { key: "supporting_progression", title: "Supporting Progression in Dance" },
        { key: "using_resources", title: "Using Resources to improve the Dance lesson" },
      ],
    };
  },
  created() {
    this.typeSelected = { value: "dance_cpd", name: "dance_cpd" };
    this.fetchData();
  },
  mounted() {},
  methods: {
    fetchData() {
      this.loading = true;

      BaseService.getAll("videos?types=library&tags=" + this.typeSelected.value)
        .then((response) => this.buildVideoList(response.data.data))
        .catch((err) => {
          console.log("Videos " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    buildVideoList(data) {
      this.videos = data;
    },
    display(video) {
      this.selectedVideo = video;
      this.showModalVideo = true;
    },
    loadVideoPath() {
      return this.selectedVideo.service_url_b;
    },
    shouldDisplay(index) {
      if (index === 0) {
        return true;
      } else if (this.currentUser.isOnTrial) {
        return false;
     } else {
        return !this.shouldShowUpgrade
      }
    },
    filteredList(section) {
      var vm = this;
      return this.orderedVideos.filter((item) => {
        let filtered = true;

        let tags = item.tags.split(",")
        filtered = tags.includes(section.key)

        if (filtered && vm.searchValue != undefined) {
          if (item.title != null) {
            filtered = item.title
              .toLowerCase()
              .includes(vm.searchValue.toLowerCase());
          }
        }

        return filtered;
      });
    },
  },
  components: {
    ResourceList,
    modalvideo,
  },
};
</script>

<style scoped>
</style>